export const REGEX = {
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    name: /^[^\s*][\w'\-,. ()]*[^_!¡?÷?¿\/\\+=@#$%ˆ&*(){}|~<>;:[\]]*$/,
    address: /[A-Za-z0-9'.\-\s,]/,
    phone: /^\d{10}$/,
    about: /[A-Za-z]{1,50}/,
    pincode: /^\d{5}(?:[-\s]\d{4})?$/,
    search: /[A-Za-z0-9]/,
    number: /^[0-9]*$/,
    decimalOrNumber: /^-{0,1}\d*\.{0,1}\d+$/,
    Phone_Number:
        /^((\([0-9]{3}\))|[0-9]{3})[-.● \s]?[\0-9]{3}[-.● \s]?[0-9]{4}$/,
    positiveNumber: /^[0-9]*$|^$/,
    website:
        /^((https?|ftp|smtp):\/\/)?(www.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#]+\/?)*$/,
    imageType: /[^\s]+(.*?)\/(jpg|jpeg|png|JPG|JPEG|PNG)$/,
    userPath: /^\/vendor\/([^/]+)\/user$/,
    removeSpace: /[^a-zA-Z0-9]/g,
    positiveDecimalOrNumber: /^$|^\d+(\.\d{0,4})?$/
};
